<section class="block-default container" [class.container-size-xs]="!block.backgroundTheme">
  <div
    class="block-default__inner"
    [class.has--theme]="!!block.backgroundTheme"
    [ngClass]="(block.backgroundTheme ? 'section-inset-y' : '') + (' bg-' + block.backgroundTheme)"
  >
    <main class="text-max-width-sm mx-auto">
      <div class="text-center" *ngIf="block.subtitle || block.title">
        <span *ngIf="block.subtitle" class="fw-bold text-secondary">{{ block.subtitle }}</span>
        <h1 class="h2 block-default__title" *ngIf="block.title">
          {{ block.title }}
          <app-icon anchor="icon-squiggle" class="heading-squiggle" *ngIf="block.title"></app-icon>
        </h1>
      </div>

      <div
        *ngIf="block.text"
        class="markdown-content mt-3"
        fstrDynamicContent
        [innerHTML]="block.text || '' | resizeHtmlImages : 1600 | stripEmbed : cookiePreferences | safe"
      ></div>
      <div *ngIf="block.button?.url" class="d-flex justify-content-center">
        <fstr-link [cssClasses]="'button block-default__button mt-4'" [button]="block.button!"></fstr-link>
        <!--<a class="button block-default__button mt-4" [routerLink]="block.button?.url">
          {{ block.button?.text }}
        </a>-->
      </div>
    </main>
  </div>

  <app-bg-wave
    *ngIf="block.backgroundTheme"
    class="bg-wave--flipped"
    [autoPlay]="true"
    [startPos]="'12s'"
    [bgColor]="'var(--bs-' + block.backgroundTheme + ')'"
    [strokeColor]="'transparent'"
  ></app-bg-wave>
</section>
